import { render, staticRenderFns } from "./FilesRequirement.vue?vue&type=template&id=7b324768"
import script from "./FilesRequirement.vue?vue&type=script&lang=ts"
export * from "./FilesRequirement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports